var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8668 5.60002C9.93719 5.60002 8.3534 7.12656 8.28239 9.05482L8.19989 11.295C8.13391 13.0864 7.44392 14.8086 6.274 16.1567C7.54072 16.2611 9.66508 16.4 11.9999 16.4C14.3341 16.4 16.3967 16.2612 17.6165 16.1569C16.5154 14.8383 15.8258 13.197 15.6726 11.4805L15.4394 8.86792C15.2742 7.01793 13.7241 5.60002 11.8668 5.60002ZM7.0832 9.01065C7.17797 6.43728 9.29164 4.40002 11.8668 4.40002C14.3455 4.40002 16.4142 6.2923 16.6346 8.76123L16.8678 11.3738C17.0054 12.915 17.65 14.3923 18.6795 15.5526C19.2377 16.1818 18.899 17.2467 17.9895 17.3287C16.7968 17.4362 14.5605 17.6 11.9999 17.6C9.38985 17.6 7.04313 17.4299 5.82344 17.3227C4.93455 17.2446 4.59987 16.1902 5.17411 15.5837C6.28431 14.4112 6.9414 12.861 7.0007 11.2508L7.0832 9.01065Z",
    fill: "#052D61"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6001 19C14.6001 19.3314 14.3315 19.6 14.0001 19.6H10.0001C9.66873 19.6 9.4001 19.3314 9.4001 19C9.4001 18.6687 9.66873 18.4 10.0001 18.4H14.0001C14.3315 18.4 14.6001 18.6687 14.6001 19Z",
    fill: "#052D61"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.da395ff5498e0ed8f93910eeb715dd53.svg";
export { ForwardRef as ReactComponent };